<template>
  <main class="about-us">
    <b-container fluid class="header">
      <b-row>
        <b-col>
          <img src="@/assets/rebrand/about/about-title.png" alt="about" class="img-about-title" />
          <h1 class="title">
            SNKRHUD is the next <br />
            evolution in sneaker <br />collecting.
          </h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p class="about-desc -wb">
            An online neighborhood for sneakerheads, the SNKRHUD platform lets people immortalize
            their <br />collections as digital collectibles. SNKRHUD's mission is driven by the
            shared passion for sneakers, not <br />just the value they hold. In this space, it's not
            about studio-produced footwear images, it's about <br />
            personal photos customized to highlight the unique features of a well-loved pair of
            kicks. <br /><br />

            The platform is broken into three distinct pillars: <b>CREATE</b>, <b>COLLECT</b>, and
            <b>COMPETE</b>, allowing sneakerheads <br />at various levels of the game to interact
            with and monetize their sneakers in an entirely new way. <br /><br />

            Showcase your favorite sneakers, invite friends, and connect with other sneakerheads.
            Explore <br />SNKRHUD'S many features including turning your physical sneakers into
            digital collectibles, an NFT <br />ecosystem, and a growing community of sneakerheads.
          </p>
          <p class="about-desc -mb">
            An online neighborhood for <br />
            sneakerheads, the SNKRHUD platform lets <br />
            people immortalize their collections as <br />digital collectibles. SNKRHUD's mission is
            <br />driven by the shared passion for sneakers, <br />not just the value they hold. In
            this <br />space, it's not about studio-produced <br />footwear images, it's about
            personal <br />photos customized to highlight the <br />unique features of a well-loved
            pair <br />of kicks. <br /><br />

            The platform is broken into three distinct <br />
            pillars: <b>CREATE</b>, <b>COLLECT</b>, and <b>COMPETE</b>, <br />allowing sneakerheads
            at various levels <br />of the game to interact with and<br />
            monetize their sneakers in an entirely<br />
            new way. <br /><br />

            Showcase your favorite sneakers, invite <br />friends, and connect with other
            <br />sneakerheads. Explore SNKRHUD'S many <br />features including turning your
            physical <br />sneakers into digital collectibles, an NFT <br />ecosystem, and a
            growing community of <br />sneakerheads.
          </p>
        </b-col>
      </b-row>
      <div class="about-bg" />
    </b-container>
    <b-container fluid class="founders">
      <img
        src="@/assets/rebrand/about/founders-divider.png"
        alt="founder divider"
        class="founder-divider"
      />
      <b-row>
        <b-col>
          <img
            src="@/assets/rebrand/about/the-founders.png"
            alt="the founders"
            class="img-the-founders"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col />
        <b-col sm="5">
          <div class="divider -mb" />
          <img
            src="@/assets/rebrand/about/brandon-martinez.png"
            alt="brandon martinez"
            class="img-founder -wb"
          />
          <img
            src="@/assets/mobile/brandon-martinez.png"
            alt="brandon martinez"
            class="img-founder -mb"
            style="width: 83%;"
          />
        </b-col>
        <b-col sm="5">
          <div class="divider two -mb" />
          <img
            src="@/assets/rebrand/about/stefan-tauber.png"
            alt="stefant auber"
            class="img-founder mtn8 -wb"
          />
          <img
            src="@/assets/mobile/stefan-tauber.png"
            alt="stefant auber"
            class="img-founder mtn8 -mb"
          />
        </b-col>
        <b-col />
      </b-row>
      <img src="@/assets/rebrand/about/about-div.png" alt="divider" class="divider -wb" />
      <b-row>
        <b-col />
        <b-col sm="5">
          <div class="divider two -mb" />
          <img
            src="@/assets/rebrand/about/cameron-henry.png"
            alt="cameron henry"
            class="img-founder mt-3 -wb"
          />
          <img
            src="@/assets/mobile/cameron-henry.png"
            alt="cameron henry"
            class="img-founder -mb mtn8 two"
          />
        </b-col>
        <b-col sm="5">
          <img
            src="@/assets/rebrand/about/hiraya-mnl.png"
            alt="hiraya mnl"
            class="img-founder mt-3 -wb"
          />
          <img src="@/assets/mobile/hiraya-mnl.png" alt="hiraya mnl" class="img-founder -mb mtn8 two" />
        </b-col>
        <b-col />
      </b-row>
      <div class="founders-bg" />
    </b-container>
  </main>
</template>
<script>
export default {
  name: 'AboutUs',
};
</script>
<style lang="scss">
@import "../assets/styles/fontstyle.css";
@import "../assets/styles/aboutus.scss";
</style>
